import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class RiskConfigService {
  static createRegulation(params) {
    return HttpUtil.post(API_ROUTES.RISKCONFIGURATION.CREATEREGULATION, params);
  }
  static updateRegulation(params, regulationId) {
    return HttpUtil.put(
      API_ROUTES.RISKCONFIGURATION.UPDATEREGULATION.replace(
        "<regulationId>",
        regulationId
      ),
      params
    );
  }
  static getRegulations(regulationType='R') {
    return HttpUtil.get(API_ROUTES.RISKCONFIGURATION.GETREGULATIONS.replace(regulationType ? "<regulationType>" : "?regulationType=<regulationType>", regulationType));
  }
  static getRegulationsNoFIlter(forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(API_ROUTES.SUPER_ADMIN_STD.GET_REGULATIONS_WITH_TYPE.replace("?regulationType=<regulationType>",""));
    } else {
      return HttpUtil.get(API_ROUTES.RISKCONFIGURATION.GETREGULATIONS.replace("?regulationType=<regulationType>",""));
    }    
  }
  static getRegulationsByStatus(status) {
    return HttpUtil.get(API_ROUTES.RISKCONFIGURATION.GETREGULATIONSBYSTATUS.replace(
      "<status>",
      status
    ));
  }
  static getRegulationDetails(regulationId, configType = '') {
    return HttpUtil.get(
      API_ROUTES.RISKCONFIGURATION.GETREGULATIONDETAILS.replace(
        "<regulationId>",
        regulationId
      ).replace(configType ? "<type>" : "?type=<type>", configType)
    );
  }
  static addRiskParameter(params, regulationId) {
    return HttpUtil.post(
      API_ROUTES.RISKCONFIGURATION.ADDRISKPARAMATER.replace(
        "<regulationId>",
        regulationId
      ),
      params
    );
  }
  static getRiskDetails(regulationId, riskId, configType = '') {
    return HttpUtil.get(
      API_ROUTES.RISKCONFIGURATION.GETRISKDETAILS.replace(
        "<regulationId>",
        regulationId
      ).replace("<riskId>", riskId).replace(configType ? "<type>" : "?type=<type>", configType)
    );
  }
  static editRiskParameter(regulationId, riskId, params, configType = '') {
    return HttpUtil.put(
      API_ROUTES.RISKCONFIGURATION.GETRISKDETAILS.replace(
        "<regulationId>",
        regulationId
      ).replace("<riskId>", riskId).replace(configType ? "<type>" : "?type=<type>", configType),
      params
    );
  }
  static deleteRiskParameter(regulationId, riskId) {
    return HttpUtil.delete(
      API_ROUTES.RISKCONFIGURATION.DELETERISKPARAMETER.replace(
        "<regulationId>",
        regulationId
      ).replace("<riskId>", riskId)
    );
  }
  static getDataSourceByRegulation(regulationId, parentId = null, configType="SUPPLIER", quantitative = true, forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.get(
        API_ROUTES.SUPER_ADMIN_STD.LIST_DS_BY_STANDARD.replace(
          "<regulationId>",
          regulationId
        ).replace(
          "<configType>",
          configType.toUpperCase()
        )
        .replace(parentId ? "<parentId>" : "&parentId=<parentId>", parentId)
        .replace("<quantitative>", quantitative)
      );
    } else {
      return HttpUtil.get(
        API_ROUTES.LINKDATASOURCE.LISTDATASOURCEBYREGULATION.replace(
          "<regulationId>",
          regulationId
        ).replace(
          "<configType>",
          configType.toUpperCase()
        )
        .replace(parentId ? "<parentId>" : "&parentId=<parentId>", parentId)
        .replace("<quantitative>", quantitative)
      );
    }    
  }
  static saveDataSourceByRegulation(regulationId, paramId, dsId, paramType = 'dataPoint', forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.patch(
        API_ROUTES.SUPER_ADMIN_STD.SAVE_DS_BY_STANDARD
        .replace("<regulationId>",regulationId)
        .replace("<paramId>", paramId)
        .replace("<dsId>", dsId)
        .replace("<paramType>", paramType)
      );
    } else {
      return HttpUtil.patch(
        API_ROUTES.LINKDATASOURCE.SAVEDATASOURCEBYREGULATION
        .replace("<regulationId>",regulationId)
        .replace("<paramId>", paramId)
        .replace("<dsId>", dsId)
        .replace("<paramType>", paramType)
      );
    }    
  }
  static publishRegulation(regulationId) {
    return HttpUtil.patch(
      API_ROUTES.RISKCONFIGURATION.PUBLISHREGULATION.replace(
        "<regulationId>",
        regulationId
      )
    );
  }
  static unlinkDatasource(regulationId, riskId, paramType = 'riskParam', forSuperAdmin = false) {
    if (forSuperAdmin) {
      return HttpUtil.delete(
        API_ROUTES.SUPER_ADMIN_STD.UNLINK_DS.replace(
          "<regulationId>",
          regulationId
        ).replace("<riskId>", riskId)
        .replace("<paramType>", paramType)
      );
    } else {
      return HttpUtil.delete(
        API_ROUTES.RISKCONFIGURATION.UNLINKDATASOURCE.replace(
          "<regulationId>",
          regulationId
        ).replace("<riskId>", riskId)
        .replace("<paramType>", paramType)
      );
    }    
  }
}
